import IconButton from "@mui/material/IconButton";
import DeleteIcon from "@mui/icons-material/Delete";

const RemoveRowButton = ({ setRows, index }) => {
  const removeRow = () => {
    setRows((prevRows) => prevRows.filter((_, i) => i !== index));
  };

  return (
    <IconButton onClick={removeRow} color="error" size="small">
      <DeleteIcon fontSize="small" />
    </IconButton>
  );
};

export default RemoveRowButton;